import { render, staticRenderFns } from "./SpaRemarks.vue?vue&type=template&id=17a4d29b"
import script from "./SpaRemarks.vue?vue&type=script&lang=js"
export * from "./SpaRemarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports